// extracted by mini-css-extract-plugin
module.exports = {"header":"textBlock_header__pNFvW","bodyWithChildren":"textBlock_bodyWithChildren__HwY6D"};